export default "__VITE_ASSET__BghiddY3__"